import { React } from '../shared/react.js';
import { SearchSidebar } from '../features/sidebar/SearchSidebar.js';
import { MapToolbar } from '../features/topbar/MapToolbar.js';
import { SpatialMap } from '../features/map/SpatialMap.js';
import { InspectorPanel } from '../features/inspector/InspectorPanel.js';
import { AccuracyControl } from '../features/tuning/AccuracyControl.js';
import { useAppState, useAppSelector, useAppRuntime } from './app.context.js';
import { TruthLens } from '../features/truth/TruthLens.js';
import { CollectionWall } from '../features/wall/CollectionWall.js';
import { FeedbackToast } from '../shared/ui/FeedbackToast.js';
const DetailSearchOverlay = React.lazy(() => import('../features/detail/DetailSearchOverlay.js').then(module => ({ default: module.DetailSearchOverlay })));

export function App() {
  const mapView = useAppSelector(state => state.mapView);
  return (
    <div className="app-shell">
      <SearchSidebar/>
      <MapToolbar/>
      {mapView === 'wall' ? <CollectionWall/> : <SpatialMap/>}
      <TruthLens/>
      <InspectorPanel/>
      <AccuracyControl/>
      <DetailSlot/>
      <FeedbackToast/>
      <StartupError/>
    </div>
  );
}

function DetailSlot() {
  const runtime = useAppRuntime();
  const id = useAppSelector(state => state.detailSearchArtworkId);
  return runtime.experimentalVisual && id ? <React.Suspense fallback={null}><DetailSearchOverlay/></React.Suspense> : null;
}

function StartupError() {
  const state = useAppState();
  return state.status === 'error' ? (
        <div className="boot-screen boot-screen--error" role="alert">
          <span className="boot-screen__mark">!</span>
          <h2>The local data pack could not be opened</h2>
          <p>{state.errorMessage}</p>
          <button type="button" onClick={() => window.location.reload()}>Retry startup</button>
        </div>
  ) : null;
}
